export default "__VITE_ASSET__hP$aRA2p__"